import React from "react";

const ogTableDef = {
  users: {
    roleName: {
      caption: "ROLE NAME",
      inputValidator: "",
      type: "search",
      enabled: true,
      selectorSource: {
        type: "static",
        table: "",
        tableField: "value",
        staticSource: [
          { value: "SALES" },
          { value: "ENGINEER" },
          { value: "CONTRIBUTOR" },
          { value: "QS" },
          { value: "ADMIN" },
          { value: "SUPERADMIN" }
        ]
      }
    },
    userName: {
      caption: "NAME",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    userEmail: {
      caption: "EMAIL (LOGIN ID)",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    userEmployeeId: {
      caption: "EMPLOYEE ID",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },

    userDesignation: {
      caption: "DESIGNATION",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    userNotes: {
      caption: "NOTES",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "textarea",
      enabled: true
    }
  },
  contacts: {
    contactCompany: {
      caption: "COMPANY NAME",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    contactTrade: {
      caption: "TRADE (CATEGORY)",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {}
    },
    contactName: {
      caption: "NAME",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },

    contactEmail: {
      caption: "EMAIL",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    contactPhone: {
      caption: "PHONE",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    contactMailingAddress: {
      caption: "MAILING ADDRESS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "textarea",
      enabled: true
    },
    contactNotes: {
      caption: "NOTES",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "textarea",
      enabled: true
    }
  },
  suppliers: {
    supplierCompany: {
      caption: "COMPANY NAME",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    supplierTrade: {
      caption: "TRADE (CATEGORY)",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    supplierName: {
      caption: "CONTACT PERSON",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },

    supplierEmail: {
      caption: "EMAIL",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    supplierFax: {
      caption: "FAX",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    supplierMailingAddress: {
      caption: "SUPPLIER MAILING ADDRESS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    supplierPhone: {
      caption: "PHONE",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    }
  },
  notices: {
    noticeTitle: {
      caption: "NOTICETITLE",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    noticeDetails: {
      caption: "NOTICE DETAILS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "textarea",
      enabled: true
    }
  },
  projectInvoices: {
    invoiceId: {
      caption: "ID",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    invoiceStatus: {
      caption: "STATUS",
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "ISSUED",
            key: "ISSUED"
          },
          {
            name: "Cheque Submitted",
            key: "Cheque Submitted"
          },
          {
            dayName: "PUBLIC HOLIDAY",
            key: "PUBLIC HOLIDAY",
            dayTypeId: "PUBLIC HOLIDAY"
          }
        ]
      },
      inputValidator: "",
      type: "search",
      enabled: true
    },
    invoiceDate: {
      caption: "DATE",
      selectorSource: {
        type: "dateBetween",
        dateFormat: "DD-MM-YYYY",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    companyName: {
      caption: "COMPANY",
      selectorSource: {
        type: "table",
        table: "contacts",
        tableField: "contactCompany",
        staticSource: []
      },
      inputValidator: "",
      type: "search",
      enabled: true
    },
    contactFax: {
      caption: "FAX",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    contactName: {
      caption: "CONTACT NAME",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    contactPhone: {
      caption: "CONTACT PHONE",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    email: {
      caption: "EMAIL",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    clientPo: {
      caption: "CLIENT PO",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    invoiceTerms: {
      caption: "TERMS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    invoiceTemplate: {
      caption: "TEMPLATE",
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "WITHOUT SIGNATURE",
            key: "65691"
          },
          {
            name: "WITH SIGNATURE",
            key: "65986"
          }
        ]
      },
      inputValidator: "",
      type: "search",
      enabled: true
    },
    mailingAddress: {
      caption: "MAILING ADDRESS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    projectName: {
      caption: "PROJECT",
      selectorSource: {
        type: "table",
        table: "projects",
        tableField: "projectName",
        staticSource: []
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    salutation: {
      caption: "SALUTATION",
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "Dear Sir,",
            key: "Dear Sir,"
          },
          {
            name: "Dear Madam,",
            key: "Dear Madam,"
          }
        ]
      },
      inputValidator: "",
      type: "search",
      enabled: true
    },
    totalInvoice: {
      caption: "TOTAL INVOICE",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    items: {
      caption: "ITEMS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "array",
      enabled: true,

      colDefs: [
        {
          name: "ITEM",
          key: "item",
          editable: true,
          resizable: true
        },
        {
          name: "DESCRIPTION",
          key: "description",
          editable: true,
          resizable: true
        },
        {
          name: "UNIT",
          key: "unit",
          editable: true,
          resizable: true
        },
        {
          name: "QUANTITY",
          key: "quantity",
          editable: true,
          resizable: true
        },
        {
          name: "RATE",
          key: "rate",
          editable: true,
          resizable: true
        },
        {
          name: "AMOUNT",
          key: "amount",
          disabled: true,
          mode: "calc",
          rule: "quantity*rate",
          resizable: true
        }
      ],
      emptyRow: {
        item: "",
        description: "",
        unit: "",
        rate: "",
        quantity: ""
      }
    }
  },
  deletedprojectInvoices: {
    invoiceId: {
      caption: "ID",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    invoiceStatus: {
      caption: "STATUS",
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "ISSUED",
            key: "ISSUED"
          },
          {
            name: "Cheque Submitted",
            key: "Cheque Submitted"
          },
          {
            dayName: "PUBLIC HOLIDAY",
            key: "PUBLIC HOLIDAY",
            dayTypeId: "PUBLIC HOLIDAY"
          }
        ]
      },
      inputValidator: "",
      type: "search",
      enabled: true
    },
    invoiceDate: {
      caption: "DATE",
      selectorSource: {
        type: "dateBetween",
        dateFormat: "DD-MM-YYYY",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    companyName: {
      caption: "COMPANY",
      selectorSource: {
        type: "table",
        table: "contacts",
        tableField: "contactCompany",
        staticSource: []
      },
      inputValidator: "",
      type: "search",
      enabled: true
    },
    contactFax: {
      caption: "FAX",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    contactName: {
      caption: "CONTACT NAME",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    contactPhone: {
      caption: "CONTACT PHONE",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    email: {
      caption: "EMAIL",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    clientPo: {
      caption: "CLIENT PO",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    invoiceTerms: {
      caption: "TERMS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    invoiceTemplate: {
      caption: "TEMPLATE",
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "WITHOUT SIGNATURE",
            key: "65691"
          },
          {
            name: "WITH SIGNATURE",
            key: "65986"
          }
        ]
      },
      inputValidator: "",
      type: "search",
      enabled: true
    },
    mailingAddress: {
      caption: "MAILING ADDRESS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    projectName: {
      caption: "PROJECT",
      selectorSource: {
        type: "table",
        table: "projects",
        tableField: "projectName",
        staticSource: []
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    salutation: {
      caption: "SALUTATION",
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "Dear Sir,",
            key: "Dear Sir,"
          },
          {
            name: "Dear Madam,",
            key: "Dear Madam,"
          }
        ]
      },
      inputValidator: "",
      type: "search",
      enabled: true
    },
    totalInvoice: {
      caption: "TOTAL INVOICE",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    items: {
      caption: "ITEMS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "array",
      enabled: true,

      colDefs: [
        {
          name: "ITEM",
          key: "item",
          editable: true,
          resizable: true
        },
        {
          name: "DESCRIPTION",
          key: "description",
          editable: true,
          resizable: true
        },
        {
          name: "UNIT",
          key: "unit",
          editable: true,
          resizable: true
        },
        {
          name: "QUANTITY",
          key: "quantity",
          editable: true,
          resizable: true
        },
        {
          name: "RATE",
          key: "rate",
          editable: true,
          resizable: true
        },
        {
          name: "AMOUNT",
          key: "amount",
          disabled: true,
          mode: "calc",
          rule: "quantity*rate",
          resizable: true
        }
      ],
      emptyRow: {
        item: "",
        description: "",
        unit: "",
        rate: "",
        quantity: ""
      }
    }
  },
  projectClaims: {
    accSubConSum: {
      caption: "ACCSUBCONSUM",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    author: {
      caption: "AUTHOR",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    bqItems: {
      caption: "BQITEMS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    bqVoList: {
      caption: "BQVOLIST",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    claimDate: {
      caption: "CLAIMDATE",
      selectorSource: {
        type: "dateBetween",
        dateFormat: "DD-MM-YYYY",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    claimId: {
      caption: "CLAIMID",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    claimStatus: {
      caption: "CLAIMSTATUS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    companyName: {
      caption: "COMPANYNAME",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    contactFax: {
      caption: "CONTACTFAX",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    contactKey: {
      caption: "CONTACTKEY",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    contactName: {
      caption: "CONTACTNAME",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    contactPhone: {
      caption: "CONTACTPHONE",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    discountPercent: {
      caption: "DISCOUNTPERCENT",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    email: {
      caption: "EMAIL",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    invItems: {
      caption: "INVITEMS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    mailingAddress: {
      caption: "MAILINGADDRESS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    projectId: {
      caption: "PROJECTID",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    projectKey: {
      caption: "PROJECTKEY",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    projectName: {
      caption: "PROJECTNAME",
      selectorSource: {
        type: "table",
        table: "projects",
        tableField: "projectName",
        staticSource: []
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    quoteId: {
      caption: "QUOTEID",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    quoteKey: {
      caption: "QUOTEKEY",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    retentionPercent: {
      caption: "RETENTIONPERCENT",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    salutation: {
      caption: "SALUTATION",
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "Dear Sir,",
            key: "Dear Sir,"
          },
          {
            name: "Dear Madam,",
            key: "Dear Madam,"
          }
        ]
      },
      inputValidator: "",
      type: "search",
      enabled: true
    },
    totPmtRcvd: {
      caption: "TOTPMTRCVD",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    updateDateTime: {
      caption: "UPDATEDATETIME",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    voItems: {
      caption: "VOITEMS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    voSum: {
      caption: "VOSUM",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    }
  },
  projectQuotes: {
    quoteId: {
      caption: "QUOTE ID",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    quoteDate: {
      caption: "QUOTE DATE",
      selectorSource: {
        type: "dateBetween",
        dateFormat: "DD-MM-YYYY",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    companyName: {
      caption: "COMPANY",
      selectorSource: {
        type: "table",
        table: "contacts",
        tableField: "companyName",
        staticSource: []
      },
      inputValidator: "",
      type: "input",
      enabled: true,
      isMust: true
    },
    projectName: {
      caption: "PROJECT NAME",
      selectorSource: {
        type: "table",
        table: "projects",
        tableField: "projectName",
        staticSource: []
      },
      inputValidator: "",
      type: "input",
      enabled: true,
      isMust: true
    },
    estimatedSchedule: {
      caption: "ESTIMATED SCHEDULE",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "textarea",
      enabled: true
    },
    genCoditions: {
      caption: "GENERAL TERMS & CONDITIONS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "textarea",
      enabled: true
    },
    techNotes: {
      caption: "TECHNICAL NOTES",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "textarea",
      enabled: true
    },
    additionalReqs: {
      caption: "ADDITIONAL NOTES",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "textarea",
      enabled: true
    },
    contactFax: {
      caption: "FAX",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    contactKey: {
      caption: "CONTACTKEY",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    contactName: {
      caption: "CLIENT'S QS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    contactPhone: {
      caption: "PHONE",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    email: {
      caption: " QS EMAIL",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    items: {
      caption: "ITEMS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "array",
      enabled: true,

      colDefs: [
        {
          name: "ITEM",
          key: "item",
          editable: true,
          resizable: true
        },
        {
          name: "DESCRIPTION",
          key: "description",
          editable: true,
          resizable: true
        },
        {
          name: "UNIT",
          key: "unit",
          editable: true,
          resizable: true
        },
        {
          name: "QUANTITY",
          key: "estimatedQuantity",
          editable: true,
          resizable: true
        },
        {
          name: "RATE",
          key: "rate",
          editable: true,
          resizable: true
        },
        {
          name: "AMOUNT",
          key: "amount",
          disabled: true,
          mode: "calc",
          rule: "estimatedQuantity*rate",
          resizable: true
        }
      ],
      emptyRow: {
        item: "",
        description: "",
        unit: "",
        rate: "",
        estimatedQuantity: ""
      }
    },
    mailingAddress: {
      caption: "MAILING ADDRESS",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    projectId: {
      caption: "PROJECTID",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    projectKey: {
      caption: "PROJECTKEY",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    author: {
      caption: "AUTHOR",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    quoteType: {
      caption: "QUOTE TYPE",
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "BQ",
            key: "BQ"
          },
          {
            name: "VO",
            key: "VO"
          }
        ]
      },
      inputValidator: "",
      type: "search",
      enabled: true
    },
    rateOnly: {
      caption: "RATE ONLY",
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "RATE ONLY",
            key: "RATE ONLY"
          },
          {
            name: "NORMAL",
            key: "NORMAL"
          }
        ]
      },
      inputValidator: "",
      type: "search",
      enabled: true
    },
    salutation: {
      caption: "SALUTATION",
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "Dear Sir,",
            key: "Dear Sir,"
          },
          {
            name: "Dear Madam,",
            key: "Dear Madam,"
          }
        ]
      },
      inputValidator: "",
      type: "search",
      enabled: true,
      isMust: true
    },
    totalAmount: {
      caption: "TOTAL QUOTE",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    updateDateTime: {
      caption: "UPDATEDATETIME",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    }
  },
  reports: {
    categ: {
      caption: "CATEG",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true,
      isMust: true
    },
    key: {
      caption: "KEY",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    reportName: {
      caption: "REPORTNAME",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    selectedCategory: {
      caption: "SELECTEDCATEGORY",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    selectedGroupBy: {
      caption: "SELECTEDGROUPBY",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    updateDateTime: {
      caption: "UPDATEDATETIME",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    }
  },
  viewReports: {
    categ: {
      caption: "CATEG",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    key: {
      caption: "KEY",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    reportName: {
      caption: "REPORTNAME",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    selectedCategory: {
      caption: "SELECTEDCATEGORY",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    selectedGroupBy: {
      caption: "SELECTEDGROUPBY",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    },
    updateDateTime: {
      caption: "UPDATEDATETIME",
      selectorSource: {
        type: "",
        table: ""
      },
      inputValidator: "",
      type: "input",
      enabled: true
    }
  },
  createFields: {
    name: {
      caption: "NAME",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    caption: {
      caption: "CAPTION",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    defaultValue: {
      caption: "DEFAULT VALUE",
      inputValidator: "",
      type: "textarea",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    placeholder: {
      caption: "PLACEHOLDER",
      inputValidator: "",
      type: "textarea",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    type: {
      caption: "INPUT TYPE",
      inputValidator: "",
      type: "search",
      enabled: true,
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "input",
            key: "input"
          },

          {
            name: "textarea",
            key: "textarea"
          },
          {
            name: "search",
            key: "search"
          },
          {
            name: "calendar",
            key: "calendar"
          },
          {
            name: "array",
            key: "array"
          },
          {
            name: "calculation",
            key: "calculation"
          },
          {
            name: "accountingRule",
            key: "accountingRule"
          },
          {
            name: "photoUpload",
            key: "photoUpload"
          }
        ]
      }
    },
    calcType: {
      caption: "CALC TYPE",
      inputValidator: "",
      type: "search",
      enabled: true,
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "subFieldsSum",
            key: "subFieldsSum"
          },

          {
            name: "mainFieldCalc",
            key: "mainFieldCalc"
          }
        ]
      }
    },
    subFieldOperation: {
      caption: "SUB OPERATION",
      inputValidator: "",
      type: "search",
      enabled: true,
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "SUM",
            key: "SUM"
          },
          {
            name: "AVERAGE",
            key: "AVERAGE"
          }
        ]
      }
    },
    subGridName: {
      caption: "SUB GRID NAME",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    subGridField: {
      caption: "SUB GRID FIELD",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    formula: {
      caption: "FORMULA",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    triggerField: {
      caption: "TRIGGER FIELD",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    inputValidator: {
      caption: "VALIDATOR",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    enabled: {
      caption: "ENABLED",
      inputValidator: "",
      type: "search",
      enabled: true,
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          { name: "true", key: true },
          { name: "false", key: false }
        ]
      }
    },
    isMust: {
      caption: "IS MANDATORY",
      inputValidator: "",
      type: "search",
      enabled: true,
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          { name: "true", key: true },
          { name: "false", key: false }
        ]
      }
    },
    isHidden: {
      caption: "IS HIDDEN",
      inputValidator: "",
      type: "search",
      enabled: true,
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          { name: "true", key: true },
          { name: "false", key: false }
        ]
      }
    },
    isSecure: {
      caption: "IS PASSWORD",
      inputValidator: "",
      type: "search",
      enabled: true,
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          { name: "true", key: true },
          { name: "false", key: false }
        ]
      }
    },
    selectorType: {
      caption: "SELECTOR TYPE",
      inputValidator: "",
      type: "search",
      enabled: true,
      selectorSource: {
        type: "static",
        table: "",
        tableField: "value",
        staticSource: [{ value: "static" }, { value: "table" }]
      }
    },
    selectorTable: {
      caption: "MANDATORY",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    numOfLines: {
      caption: "NO. OF LINES",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    dateFormatOut: {
      caption: "DATE FORMAT OUT",
      inputValidator: "",
      type: "search",
      enabled: true,
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "DD-MM-YYYY h:mm a",
            key: "DD-MM-YYYY h:mm a"
          },

          {
            name: "DD-MM-YYYY",
            key: "DD-MM-YYYY"
          }
        ]
      }
    },
    dateFormat: {
      caption: "DATE FORMAT",
      inputValidator: "",
      type: "search",
      enabled: true,
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "dd-MM-yyyy h:mm a",
            key: "dd-MM-yyyy h:mm a"
          },

          {
            name: "dd-MM-yyyy",
            key: "dd-MM-yyyy"
          }
        ]
      }
    },
    dateMaxDetail: {
      caption: "MAX DETAIL",
      inputValidator: "",
      type: "search",
      enabled: true,
      selectorSource: {
        type: "static",
        table: "",
        tableField: "name",
        staticSource: [
          {
            name: "minute",
            key: "minute"
          },
          {
            name: "hour",
            key: "hour"
          },
          {
            name: "day",
            key: "day"
          }
        ]
      }
    }
  },
  createTable: {
    name: {
      caption: "FORM NAME",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    caption: {
      caption: "FORM CAPTION",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    menu: {
      caption: "MENU CAPTION",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    createNotifyText: {
      caption: "CREATE TEXT",
      inputValidator: "",
      type: "textarea",
      numOfLines: "5",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    updateNotifyText: {
      caption: "UPDATE TEXT",
      inputValidator: "",
      type: "textarea",
      numOfLines: "5",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    deleteNotifyText: {
      caption: "DELETE TEXT",
      inputValidator: "",
      type: "textarea",
      numOfLines: "5",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    fullText: {
      caption: "FULL TEXT",
      inputValidator: "",
      type: "textarea",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    }
  },
  listOfTables: {
    name: {
      caption: "TABLE NAME",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    caption: {
      caption: "TABLE CAPTION",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    },
    menu: {
      caption: "MENU CAPTION",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      }
    }
  },
  menuDesigner: {
    name: {
      caption: "MENU NAME",
      inputValidator: "",
      type: "input",
      enabled: true,
      selectorSource: {
        staticSource: []
      },
      isMust: true
    }
  }
};

export default ogTableDef;



// WEBPACK FOOTER //
// ./src/app/components/TableDefinitions/getOgDefs.jsx